import React, { FC, useEffect, useState } from 'react'
import { ReactComponent as TrashSvg } from 'static/svg/icon-trash.svg'
import { ReactComponent as DocumentSvg } from 'static/svg/document.svg'
import * as S from './styles'
import { Typography } from '@telavita-core/react-design-kit'
import { LoadingSpinner } from '../LoadingSpinner'

export type FileItemProps = {
  id: string
  file?: File
  name?: string
  preview?: string
  uploaded?: boolean
  error?: boolean
  progress?: number
  size?: number
  type?: string
}

export interface FileListProps {
  files: FileItemProps[]
  onDelete?: (id: string) => Promise<void>
}

const FileList: FC<FileListProps> = ({ files, onDelete }) => {
  const [deleteLoadingList, setDeleteLoadingList] = useState<string[]>([])
  useEffect(() => {
    // Revogar os uris para evitar vazamentos de memória, será executado na desmontagem
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview))
  }, [])

  const fileIsImage = (file: FileItemProps) => file?.type?.includes('image')

  const handleDelete = async (id: string) => {
    setDeleteLoadingList((loadingList) => [...loadingList, id])
    try {
      await onDelete(id)
    } finally {
      setDeleteLoadingList((loadingList) => loadingList.filter((loading) => loading !== id))
    }
  }

  const formatBytes = (bytes) => {
    const BASE = 1024
    const suffixes = ['bytes', 'KB', 'MB', 'GB', 'TB']
    const index = Math.floor(Math.log(bytes) / Math.log(BASE))
    return (bytes / Math.pow(BASE, index)).toFixed(2) + ' ' + suffixes[index]
  }


  const isLoading = (id: string): boolean => {
    return deleteLoadingList.includes(id)
  }

  return (
    <S.ContainerList>
      {files.map((file) => (
        <S.ListItem key={file.id}>
          <S.Wrapper>
            {fileIsImage(file) ? (
              <S.Preview src={file.preview} />
            ) : (
              <S.IconPreview>
                <DocumentSvg />
              </S.IconPreview>
            )}
            <S.Info>
              <S.FileNameText>
                <Typography variant='content2'>{file.name}</Typography>
              </S.FileNameText>
              <S.FileSize>
                <Typography variant='content3'>{formatBytes(file.size)}</Typography>
              </S.FileSize>
            </S.Info>
          </S.Wrapper>
          <S.Wrapper>
            {isLoading(file.id) ? (
              <LoadingSpinner />
            ): (
              <S.TrashIconWrapper onClick={() => handleDelete(file.id)}>
                <TrashSvg />
              </S.TrashIconWrapper>
            )}
          </S.Wrapper>
        </S.ListItem>
      ))}
    </S.ContainerList>
  )
}

export default FileList
